import { get, post } from './base'

const contactApi = {
  // 获取组名列表
  groups(pageIndex, size = 12) {
    return get('api/payload/contacts/groups?size=' + size + '&page=' + pageIndex)
  },

  delete(ids) {
    return post('api/contactGroup/deleteContactGroup', { ids })
  },

  addGroup(groupName) {
    return post('api/contactGroup/addContactGroup', { groupName })
  },

  updateGroup(id, name) {
    return post('api/contactGroup/updateGroupName', { id, name })
  },

  getContactsByGroupId(groupId, pageIndex, size = 12) {
    return get('api/payload/contactsByGroup', { groupId, page: pageIndex, size })
  },

  removeContactsByGroupId(groupId, contactIdList) {
    return post('api/contactGroup/moveOutGroup', { groupId, contactIdList })
  },

  addContactsByGroupId(groupId, contactIdList) {
    return post('api/contactGroup/moveInGroup', { groupId, contactIdList })
  },
}

export default contactApi
